module.exports = __webpack_public_path__ + "public/images/love-learning-text.48f9cf99faa1de0996157e2ddba3b9b4.png";